/**
 * The service path provider - provides resolved URLs for services.
 */
var ServicePathProviderService = /** @class */ (function () {
    /**
     * @param  {ConsoleService} console
     */
    function ServicePathProviderService(console) {
        this.console = console;
        this.servicePathMap = new Map();
    }
    /**
     * @param  {any} serviceMap
     */
    ServicePathProviderService.prototype.setServiceMap = function (serviceMap) {
        var _this = this;
        var rawLength = Object.keys(serviceMap).length;
        var mapLength = serviceMap.size;
        if (rawLength > 0) {
            this.console.log('Setting service map containing ' + rawLength + ' mappings.');
            for (var _i = 0, _a = Object.keys(serviceMap); _i < _a.length; _i++) {
                var serviceKey = _a[_i];
                this.addServiceMapping(serviceKey, serviceMap[serviceKey]);
            }
        }
        else if (mapLength > 0) {
            this.console.log('Setting service map containing ' + mapLength + ' mappings.');
            serviceMap.forEach(function (value, key, map) { return _this.addServiceMapping(key, value); });
        }
    };
    /**
     * @param  {string} serviceName
     * @param  {string} servicePath
     */
    ServicePathProviderService.prototype.addServiceMapping = function (serviceName, servicePath) {
        this.servicePathMap.set(serviceName, servicePath);
        this.console.log('Adding service mapping: ' + serviceName + ' : ' + servicePath);
    };
    /**
     * @param  {string} serviceName
     * @return {string|undefined} The resolved path for the service.
     */
    ServicePathProviderService.prototype.getServicePath = function (serviceName) {
        var servicePath = this.servicePathMap.get(serviceName);
        if (servicePath === undefined || servicePath.length === 0) {
            // TODO: Why does this no longer throw an error?
            this.console.log('No service path for service name: ' + serviceName);
        }
        return servicePath;
    };
    return ServicePathProviderService;
}());
export { ServicePathProviderService };
//# sourceMappingURL=service-path-provider.js.map